window.OKJS = window.OKJS || {};
(function (OKJS) {
    OKJS.Share = {
        
        init: function () {
            var shareBtns = document.querySelectorAll('.js-tooltip--click');

            if (shareBtns.length > 0) {
                OKJS.Share.setupClickShareMiniOverlay(shareBtns);
            }
        },

        setupClickShareMiniOverlay: function (shareBtns) {
            for (var i = 0; i < shareBtns.length; i++) {

                var btn = shareBtns[i];

                btn.addEventListener("click", function (e) {

                    var toolTipParent = e.currentTarget.classList.contains('tooltip') ? e.currentTarget : e.currentTarget.parentElement;
                    
                    if (toolTipParent.classList.contains('tooltip--show')) {
                        toolTipParent.classList.remove('tooltip--show');
                    } else {
                        toolTipParent.classList.add('tooltip--show');
                    }

                });  
            };
        }
    };
}(window.OKJS));
